import { render } from "./PersonIcon.vue?vue&type=template&id=1e881a97&scoped=true"
import script from "./PersonIcon.vue?vue&type=script&lang=js"
export * from "./PersonIcon.vue?vue&type=script&lang=js"

import "./PersonIcon.vue?vue&type=style&index=0&id=1e881a97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e881a97"]])

export default __exports__